import { Box } from "@gemini/core";

export const ErrorPageBackground = () => (
  <Box
    as="svg"
    unsafe_style={{
      maxWidth: `${340 / 16}rem`,
    }}
    justifySelf="start"
    paddingLeft="spacing.32"
    /**
     * Commented width and height because Box transform them into CSS
     * properties, giving `width: 340` without unit, which is not
     * valid. 👇
     */
    // width="340"
    // height="77"
    width="100%"
    height="auto"
    viewBox="0 0 340 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M145.63 55.29c-11.94-.2-14.65 14.08-14.65 14.08s3.3 9.28 15.24 9.47c11.94.19 15.67-9.74 15.67-9.74s-4.31-13.62-16.26-13.81Z"
      fill="#e0e0e0"
    />
    <path
      d="m142.18 29.89 3.01-4.92-28.16-23.6H44.59v6.89l26.16 27.52 30.18 5.9 41.25-11.8Z"
      fill="#c7c7c7"
    />
    <path
      d="M32.12 15.22V-.16h9.48v4.85l2.99-3.31 24.14 23.59 4.03 3.93 5.03 19.66-9.06 30.1H22.46v-52.7l9.66-10.74Z"
      fill="#e0e0e0"
    />
    <path
      d="M68.73 24.97h76.46v53.7H68.73v-53.7Z"
      fill="#f7f7f8"
    />
    <path
      d="M79.3 39.23h16.1v13.76H79.3V39.23Z"
      fill="#c7c7c7"
    />
    <path
      d="M101.93 38.73h14.09v39.93h-14.09V38.73Z"
      fill="#e0e0e0"
    />
    <path
      d="M132.12 43.65v-4.92h6.03v4.92h-6.03Zm.5 3.93h5.53v4.92h-6.03v-4.92h.5Zm-10.56-8.85h6.03v4.92h-6.03v-4.92Zm0 8.85h6.03v4.92h-6.03v-4.92ZM47.1 44.14v-4.91h6.04v4.91h-6.03Zm.5 3.93h5.54V53h-6.03v-4.92h.5Zm-10.56-8.84h6.04v4.91h-6.04v-4.91Zm0 8.84h6.04V53h-6.04v-4.92Z"
      fill="#c7c7c7"
    />
    <path
      d="M7.12 48h.76v29.22h-.76V48Z"
      fill="#aeaeae"
    />
    <path
      d="M.14 51.72c-.05 10.22 7.3 18.54 7.3 18.54s7.44-8.25 7.49-18.47c.05-10.22-7.31-18.54-7.31-18.54S.18 41.5.14 51.72Z"
      fill="#e0e0e0"
    />
    <path
      d="M16.96 48h.76v29.22h-.75V48Z"
      fill="#aeaeae"
    />
    <path
      d="M9.98 51.72c-.05 10.22 7.3 18.54 7.3 18.54s7.44-8.25 7.49-18.47c.05-10.22-7.3-18.54-7.3-18.54s-7.44 8.25-7.5 18.47Z"
      fill="#c7c7c7"
    />
    <path
      d="M260.78 50.83c-3.95-8.04 5.44-23.27 17.93-27.99 21.13-8 44.45 16.61 41.82 26.23-3.33 12.28-52.83 15.8-59.75 1.76Z"
      fill="#e0e0e0"
    />
    <path
      d="M285.75 46.21h1.28v30.74h-1.28V46.21Z"
      fill="#aeaeae"
    />
    <path
      d="m290.66 47.8 1.22.4-4.91 14.78-1.22-.4 4.91-14.78Z"
      fill="#aeaeae"
    />
    <path
      d="M314.26 29.64c-17.22 1.82-18.65 22.55-18.65 22.55s6.34 12.58 23.56 10.77a23.57 23.57 0 0 0 20.88-16.57s-8.56-18.57-25.79-16.75Z"
      fill="#c7c7c7"
    />
    <path
      d="M317.95 46.21h-1.28v30.74h1.28V46.21Z"
      fill="#aeaeae"
    />
    <path
      d="m313.04 47.8-1.21.4 4.9 14.78 1.22-.4-4.9-14.78Zm-135.8 15.66h-.58v13.72h.58V63.46Z"
      fill="#aeaeae"
    />
    <path
      d="M169.36 50.9c-.05 10.29 7.28 18.66 7.28 18.66s7.41-8.3 7.46-18.6c.05-10.27-7.28-18.65-7.28-18.65s-7.41 8.3-7.46 18.6Z"
      fill="#c7c7c7"
    />
    <path
      d="M230.52 43.86h-50.37l2.67-1.25h50.38l-2.68 1.25Z"
      fill="#aeaeae"
    />
    <path
      d="M279.17 77.03H228.8l.17-55.35h50.44l-.24 55.35Z"
      fill="#f7f7f8"
    />
    <path
      d="m231.17 18.37.48 2.07-2.68 1.24-.17 55.35h-46.28l.3-34.41-2.67 1.24-.48-2.13 2.67-1.18 46.16-21 2.67-1.18Z"
      fill="#e0e0e0"
    />
    <path
      d="M279.41 21.68h-50.43l2.67-1.24h50.44l-2.68 1.24Z"
      fill="#c7c7c7"
    />
    <path
      d="M282.08 20.44h-50.43l-.48-2.07h50.38l.53 2.07Z"
      fill="#f7f7f8"
    />
  </Box>
);
